<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">Gráficos</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100">
              <md-field>
                <label>Tipo de Gráfico</label>
                <md-select v-model="tipo_grafico">
                  <md-option value="unidades">Pontuação de Unidades</md-option>
                  <md-option value="categorias_unidades">Categorias e Unidades por um período</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout mb-20">
              <div class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100">
                <md-field>
                  <label v-if="tipo_grafico != 'categorias_unidades'">Mês Início</label>
                  <label v-if="tipo_grafico == 'categorias_unidades'">Mês</label>

                  <md-select v-model="mes_inicio">
                    <md-option
                      v-for="(item,index) in meses"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div
                class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100"
                v-if="tipo_grafico != 'categorias_unidades'"
              >
                <md-field>
                  <label>Mês Fim</label>
                  <md-select v-model="mes_fim">
                    <md-option value="-1">-Mês Fim-</md-option>
                    <md-option
                      v-for="(item,index) in meses"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100">
                <md-field>
                  <label>Ano</label>
                  <md-input name="ano" type="text" placeholder="Ano" v-mask="'####'" v-model="ano"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout mb-20">
              <div class="md-layout-item">
                <label>Unidades</label>
                <checkbox_list
                  v-if="show_checkboxlist"
                  v-bind:items="items_unidade"
                  v-model="ids_unidades"
                  field_value="id"
                  field_text="nome"
                  show_marcatodos="1"
                ></checkbox_list>
              </div>
            </div>

            <div class="md-layout mb-20">
              <div
                class="md-layout-item md-size-30 md-small-size-45 md-xsmall-size-100"
                v-if="items_modelo.length > 1"
              >
                <md-field>
                  <label>CheckList</label>
                  <md-select v-model="id_modelo" v-on:change="load_setores">
                    <md-option
                      v-for="(item, index) in items_modelo"
                      :value="item.id"
                      :key="index"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-45 md-xsmall-size-100"
                v-if="items_categoria.length > 0  && tipo_grafico != 'categorias_unidades' "
              >
                <md-field>
                  <label>Setor</label>
                  <md-select v-model="id_setor">
                    <md-option value="-1">--NOTA GERAL--</md-option>
                    <md-option
                      v-for="(item, index) in items_categoria"
                      :value="item.id"
                      :key="index"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-5 md-small-size-10 md-xsmall-size-100">
                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-success"
                  v-on:click="load_data"
                  :disabled="disabled_button"
                  type="button"
                >
                  <md-icon>search</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <CardCadastro v-if="loaded_grafico">
      <div slot="header">
        <h4 class="title">Resultado</h4>
      </div>

      <div
        slot="header_button"
        style="width: 99%; float: right; text-align: right"
        v-if="show_print_button"
      >
        <md-button
          type="button"
          class="md-round md-just-icon md-primary"
          style="text-align: center"
          v-on:click="call_print"
          v-bind:disabled="loading_print"
        >
          <md-icon>print</md-icon>
        </md-button>
      </div>
      <div slot="body">
        <div v-if="loading" class="md-layout">
          <div class="md-layout-item md-size-100 box-carregando">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="4"
              md-mode="indeterminate"
            >Carregando..</md-progress-spinner>
          </div>
        </div>
        <div v-if="loading_print" class="md-layout">
          <div class="md-layout-item md-size-100 box-carregando">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="4"
              md-mode="indeterminate"
            >Gerando impressão..</md-progress-spinner>
          </div>
        </div>
        <div v-if="grafico != null && grafico.data.length > 0 ">
          <div class="box-grafico" v-for="(item, index) in grafico.paginacao" :key="index">
            <bargroup
              :unidades="item.unidades"
              :data="grafico.data"
              :onAppeared="setImagemJpeg"
              :index="index"
              :titulo="grafico.titulo"
            ></bargroup>
          </div>
        </div>
      </div>
    </CardCadastro>
  </div>
</template>
<script>
import CardCadastro from "../../../components/CardCadastro";
import Util from "../../../library/Util";
import checkbox_list from "../../components/checkbox_list";
import serviceUnidade from "../../../services/EstabelecimentoService";
import serviceModelo from "../../../services/ModeloChecklistService";
import Api from "../../../library/Api";
import bargroup from "../../components/graficos/bargroup";
import mixin_user from "../../../library/mixin/user";
import serviceSerializator from "../../../services/SerializatorService";

import Swal from "sweetalert2";

export default {
  mixins: [mixin_user],
  components: {
    CardCadastro,
    checkbox_list,
    bargroup
  },
  data() {
    return {
      meses: [],
      mes_inicio: 1,
      mes_fim: 1,
      ano: 2019,
      ids_unidades: "",
      items_unidade: [],
      items_modelo: [],
      items_categoria: [],
      disabled_button: true,
      grafico: null,
      show_checkboxlist: false,
      id_modelo: -1,
      id_setor: -1,
      loading: false,
      loaded_grafico: false,
      loading_print: false,

      images_jpeg: [],
      show_print_button: false,
      tipo_grafico: "unidades"
    };
  },
  mounted() {
    this.meses = [
      { value: 1, label: "Janeiro" },
      { value: 2, label: "Fevereiro" },
      { value: 3, label: "Março" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Maio" },
      { value: 6, label: "Junho" },
      { value: 7, label: "Julho" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Setembro" },
      { value: 10, label: "Outubro" },
      { value: 11, label: "Novembro" },
      { value: 12, label: "Dezembro" }
    ];

    this.ano = new Date().getFullYear();
    var self = this;

    serviceUnidade.getList("", "nome", "asc").then(function(response) {
      console.log("unidades?");
      console.log(response);
      self.items_unidade = response.data;
      self.disabled_button = false;
      self.show_checkboxlist = true;
    });

    serviceModelo.getList("", "nome", "asc").then(function(response) {
      self.items_modelo = response.data;

      if (self.items_modelo.length > 0) {
        self.id_modelo = self.items_modelo[0].id;
        self.load_setores();
      }
    });
  },
  methods: {
    call_print() {
      let self = this;
      console.log("call print?");

      if (this.tipo_grafico == "categorias_unidades") {
        this.mes_fim = this.mes_inicio;
      }

      var json = {
        images_jpeg: this.images_jpeg,
        tabela: this.grafico.tabela,
        id_cliente: this.getGlobalUserProp("id_cliente"),
        id_setor: this.id_setor,
        ids_unidades: this.ids_unidades,
        ano: this.ano,
        mes_inicio: this.mes_inicio,
        mes_fim: this.mes_fim,

        periodo_inicio: this.mes_inicio + "/" + this.ano,
        periodo_fim: this.mes_fim + "/" + this.ano,
        tipo: this.tipo_grafico,
        tipo_grafico: this.tipo_grafico
      };
      this.loading_print = true;

      var data = {
        data_value: JSON.stringify(json),
        variableName: "print",
        data_type: "grafico"
      };

      serviceSerializator.salvar(data).then(function(response) {
        console.log(response.data);
        self.loading_print = false;
        if (response.data != null) {
          if (response.data.url != null) {
            window.open(response.data.url);
          }
        }
      });
    },

    setImagemJpeg(data, index) {
      let self = this;
      this.images_jpeg[index] = data;

      if (index == this.grafico.paginacao.length - 1) {
        setTimeout(function() {
          self.show_print_button = true;
        }, 1000);
      }
    },

    load_data() {
      var self = this;

      self.grafico = null;

      if (this.ids_unidades == "" || this.ids_unidades == ",") {
        Swal.fire({
          title: "Atenção!",
          html: "Selecione pelo menos uma unidade!",
          // showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          // cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        });
        return false;
      }

      var data = {
        periodo_inicio: this.mes_inicio + "/" + this.ano,
        periodo_final: this.mes_fim + "/" + this.ano,
        id_cliente: this.getGlobalUserProp("id_cliente"),
        id_modelo: this.id_modelo,
        ids_unidades: this.ids_unidades,
        id_setor: this.id_setor,
        tipo_grafico: this.tipo_grafico
      };

      if (this.id_setor < 0) {
        data["id_setor"] = "";
      }

      self.loaded_grafico = true;
      self.loading = true;

      self.show_print_button = false;
      self.images_jpeg = [];
      console.log(data);
      Api.Call("graficos", "POST", data).then(function(response) {
        self.grafico = response.data;
        self.loading = false;
        self.loaded_grafico = true;
        console.log("Retorno?");
        console.log(response);
        console.log(self.loaded_grafico);

        if (self.grafico.data.length <= 0) {
          Swal.fire({
            title: "Atenção!",
            html: "Não há dados para o período pesquisado!",
            // showCancelButton: true,
            confirmButtonClass: "md-button md-success",
            // cancelButtonClass: "md-button md-danger",
            buttonsStyling: false
          });

          return false;
        }
      });
    },
    load_setores() {
      var self = this;
      self.disabled_button = true;
      Api.Call("modelo_checklist_categorias/" + this.id_modelo).then(function(
        response
      ) {
        self.items_categoria = response.data;
        self.disabled_button = false;
      });
    }
  }
};
</script>